<template>
    <div class="d-flex justify-content-center vh-200">
        <PasswordForm
            :showOldPassword="true"
            :formTitle="$t(formTitle)"
            :buttonText="$t('users.users_button__change_password')"
            @submit="handleChangePassword"
        />
    </div>
</template>

<script>
import { PasswordForm } from '@/components';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { changePassword } from '@/api/users';
import { useRouter } from 'vue-router';

export default {
    props: {
        token: {
            type: String,
            required: false,
        },
        formTitle: {
            type: String,
            default: 'users.users_title__change_password',
        },
    },
    components: {
        PasswordForm,
    },
    setup() {
        const { t } = useI18n();
        const router = useRouter();
        const Swal = inject('$swal');

        const handleChangePassword = async formData => {
            if (formData instanceof Event) {
                return;
            }
            try {
                const { oldPassword, newPassword } = formData;
                const response = await changePassword(oldPassword, newPassword);
                await Swal.fire({
                    title: 'Success',
                    text: t(`users.${response.data.message}`),
                    icon: 'success',
                    showConfirmButton: true,
                });
                router.push({ path: '/' });
            } catch (error) {
                await Swal.fire({
                    title: 'Error',
                    text: t(`users.${error.response.data.error}`),
                    icon: 'error',
                    showConfirmButton: true,
                });
                // reload the page to clear the form
                router.go();
            }
        };

        return {
            handleChangePassword,
        };
    },
};
</script>
